import {AfterViewChecked,Component,EventEmitter,HostListener,Inject,OnDestroy,OnInit,Renderer2,ViewChild} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {catchError,filter,finalize,first} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {forkJoin,of,Subject,Subscription} from 'rxjs';
import * as moment from 'moment';
import {Moment} from 'moment';

import {HttpClient} from '@angular/common/http';
import {Anomalie,SettingsNFState,SettingsWFObjectState} from '@domain/settings/settings';
import {NDFService} from '../../../ndf.service';
import {Genre,ModeParticipants,Prestation,TypePrestation} from '@domain/prestation/prestation';
import {Result,TypeCodeErreur} from '@domain/common/http/result';
import {ConfirmService} from '@share/component/confirmation/confirm.service';
import {AppState} from '@domain/appstate';
import {SaisieState} from '@domain/saisie/saisie';
import {DocumentListComponent} from "../../../../document/document-list.component";
import {User} from "@domain/user/user";
import {PrestTaux} from "@domain/prestation/prest-taux";
import {FraisService} from "../../../../frais/frais.service";
import {LienParticipant} from "@domain/ndf/lien-participant";
import {ParticipantsPopinComponent} from "../../../../participants/popin/participants-popin.component";
import {ZoneUtilisateurComponent} from '../../../../zone-utilisateur/zone-utilisateur.component';
import {TypeEntiteNF} from "@domain/typeentite/typeEntite";
import {LieuDepense} from "@domain/typeentite/typeEntiteParam";
import {Omp} from "@domain/omp/omp";
import {Od} from "@domain/od/od";
import {Ville} from "@domain/geographie/ville";
import {Pays} from "@domain/geographie/pays";
import {TypePortee} from "@domain/workflow/workflow";
import {TypeGeographie} from "@domain/geographie/typeGeographie";
import {NgModel} from "@angular/forms";
import * as typeEntiteActions from "../../../../../reducers/type-entite";
import {GeographieView} from "@domain/geographie/geographieView";
import {TypeParticipant} from "@domain/participant/participant-avec-favoris";
import {ContextDocument} from "@domain/document/context-document"
import {NDFFraisAddMesFraisComponent} from './ndf-frais-add-mes-frais/ndf-frais-add-mes-frais.component';
import {IntegrationMesFrais} from '@domain/ndf/integration-mes-frais';
import {Document} from "@domain/document/document";
import {NDFFraisAddMotifComponent} from './ndf-frais-add-mes-frais/ndf-frais-add-motif/ndf-frais-add-motif.component';
import {MatLegacyTabGroup as MatTabGroup} from "@angular/material/legacy-tabs";
import {FraisErreur} from "@domain/ndf/frais-erreur"
import {FrequenceAutorisee} from "@domain/ndf/frequence-autorisee";
import {NiveauAutorisation} from "@domain/vehicule/autorisation";
import {PopupDetailCalculIkComponent} from "@components/ndf/popup-detail-calcul-ik/popup-detail-calcul-ik.component";
import {ODService} from "@components/od/od.service";
import {SaisieTemps} from "@domain/od/saisie-temps";
import {Ndf} from "@domain/ndf/ndf";
import {ListeTrajet,TrajetType} from "@domain/Trajet/ListeTrajet";
import {NDFFraisAddTourneeComponent} from "@components/ndf/ndf-details/ndf-frais/ndf-frais-add/ndf-frais-add-mes-frais/ndf-frais-add-tournee/ndf-frais-add-tournee.component";
import {Tournee} from "@domain/Tournee/tournee";
import {TourneeService} from "@components/ndf/ndf-details/ndf-frais/ndf-frais-add/ndf-frais-add-mes-frais/ndf-frais-add-tournee/tournee.service";
import {Page} from "@domain/common/http/list-result";
import {TypeBareme} from "@domain/prestation/TypeBareme"
import {TrajetRenommerComponent} from "@components/ndf/ndf-details/ndf-frais/ndf-frais-add/ndf-frais-add-mes-frais/ndf-frais-add-trajet/trajet-renommer.component";
import {AdresseService} from "@share/component/adresse/adresse.service";
import {TooltipPrestationComponent} from "@share/directive/tooltip/prestation/tooltip-prestation.component";
import {DatePipe} from "@share/pipe/custom-date.pipe";
import {DocumentDropperComponent} from "../../../../document/document-dropper.component";
import {DocumentService} from "../../../../document/document.service";
import {FraisTaxeService} from "@components/ndf/ndf-details/ndf-frais/ndf-frais-add/frais-taxe.service";
import {Adresse} from "@domain/profil/adresse";
import {LieuParamFrais} from "@domain/common/lieu/lieu-param-frais";
import {environment} from "@environments/environment";
import {EtatOperation} from "@domain/opecarte/list-opecarte";
import {TooltipPosition} from "@share/directive/tooltip/tooltip.directive";
import {TypeDistance} from "@domain/prestation/unite";
import {MatErrorModel,MatHintModel} from "@share/component/custom-input/custom-input.model";
import {PieceJointeUserService} from "@components/workflow/piece-jointe-user.service";
import {PieceJointeParam} from "@domain/admin/parametre/demat/piece-jointe-param";
import {TypeDocument} from "@domain/admin/parametre/demat/type-document";
import {CustomTagWithSelect,NO_SELECTION} from "@components/document/custom-select-document-tag";
import {handleResult} from "@share/utils/handle-result";
import {filterFirstNotNull} from "@share/utils/rxjs-custom-operator";

@Component({
    host: {'data-test-id': 'ndf-frais-add'},
    templateUrl: './ndf-frais-add.component.html',
    styleUrls: ['./ndf-frais-add.component.scss'],
    providers: [DocumentService,FraisTaxeService]
})
export class NDFFraisAddComponent implements OnInit,AfterViewChecked,OnDestroy {
    /** Définition de la classe pour l'utilisation dans la page HTML */
    ContextDocument = ContextDocument;
    TooltipPrestationComponent = TooltipPrestationComponent;
    Anomalie = Anomalie;

    /* Déclaration pour accès dans le template */
    Genre = Genre;
    TypeParticipant = TypeParticipant;
    TypePortee = TypePortee
    TypeBareme = TypeBareme;

    /** Indicateur d'enregistrement en cours */
    isSaving: boolean = false;

    /** Indicateur de suppression en cours */
    isDeleting: boolean = false;

    /** Indicateur de rejet en cours */
    isRejecting: boolean = false;

    /** Indicateur d'ajout à la note en cours */
    isAddingToNote: boolean = false;

    /** Cours taux */
    coursTaux: number

    /** Indicateur de traitement en cours (enregistrement ou suppression ou rejet du frais) */
    get isProcessing(): boolean {
        return this.isSaving || this.isDeleting || this.isRejecting || this.isAddingToNote;
    }

    /** Indicateur de chargement en cours */
    isLoading: boolean = true;

    /** Indique si la liste est vide */
    isListeEmpty: boolean = false;

    /** Types de prestation **/
    TypePrestation = TypePrestation;

    /** Indique qu'un calcul de distance est en cours */
    isComputingDistance: boolean = false;

    /** Liste des participants (invités) */
    listeParticipants: Array<LienParticipant>;

    /** Modes de gestion des participants */
    ModeParticipants = ModeParticipants;

    /** Informations de saisie */
    saisieState: SaisieState = null;

    /** Liste des souscriptions */
    private listeSouscriptions: Array<Subscription> = new Array<Subscription>();

    /** Montant unitaire modifiable (pour les prestations de type forfait) */
    montantUnitaire: number | string = 0;

    /** Utilisateur connecté */
    user: User;

    /** Type entité de la ndf */
    typeEntite: TypeEntiteNF;

    /** Types de lieu autorisés */
    listeTypeGeo = new Array<TypeGeographie>();

    /** Référence vers le composant de la liste des documents */
    @ViewChild('listeDocument',{ static: true })
    listeDocument?: DocumentListComponent;

    /** Référence vers la zone de drag 'n drop de la preview */
    @ViewChild('documentDropper',{ static: true })
    documentDropper?: DocumentDropperComponent;

    /** Référence vers l'autocomplete du lieu */
    @ViewChild('geographie')
    geographie: NgModel;

    /** Composant enfant zone utilisateur */
    @ViewChild(ZoneUtilisateurComponent) childZoneUtilisateurComponent: ZoneUtilisateurComponent;

    /** Évènement de validation de la liste des participants */
    eventSaveParticipant: EventEmitter<Array<LienParticipant>> = new EventEmitter<Array<LienParticipant>>();

    /** Onglet courant */
    currentTab: NdfFraisAddTab = NdfFraisAddTab.saisieFrais;

    /** Montant saisie à l'initialisation de l'objet */
    montantInit: number = 0;

    /** Montant sauvegardé associé à l'opeCarte */
    montantInitLieOpCarte: number = 0;

    /** Cumul restant à afficher */
    cumulRestant: string;

    /** Composant enfant zone utilisateur */
    @ViewChild(NDFFraisAddMesFraisComponent) childNDFFraisAddMesFraisComponent: NDFFraisAddMesFraisComponent;

    /** Composant onglets */
    @ViewChild("matTabGroup",{ static: true }) matTabGroup: MatTabGroup;

    /** True si une erreur de fréquence est levé */
    hasFrequenceAutoriseeError = false;

    /** Indique si le frais en cours de visualisation provient du calcul des IJ */
    isIJ: boolean = false;

    /** Indemnité de l'IJ */
    indemniteIJ: PrestTaux;

    /** Import de l'énum pour le DOM */
    niveauAutorisation: typeof NiveauAutorisation = NiveauAutorisation;

    /** La saisie des temps */
    saisieTemps: SaisieTemps;

    /** Indique si la prestation actuelle est une ik */
    isIk: boolean = false;

    /** Mémorise l'état de validité sur le nombre de PJ au chargement */
    wasPjValid: boolean;

    /** Flag indiquant que les PJ ont changé et que la liste des ndf doit être rechargée */
    needRefreshAfterPjChanged: boolean = false;

    /** Indique si la quantité est bloquée par la selection d'un trajet admin */
    isQuantiteBlockedByAdminTrajet = false;

    /** Indique si peut afficher la checkbox retenir trajet */
    canShowRetenirTrajet = false;

    /** Indique si l'user souhaite retenir un trajet */
    isRetenirTrajet = false;

    /** Indique que la zone d'upload avec drag 'n drop est affichée */
    isShowUploader: boolean = false;

    /** Indique à la liste des PJ qu'il faut la recharger */
    refreshListPj$: Subject<void> = new Subject<void>();

    /** Flag indiquant que les types de PJ ont été modifiés */
    isTypePjTouched: boolean = false;

    /** Données transmises lors de la fermeture manuelle de la popup */
    get dialogCloseResult() {
        return {
            //Rechargement de la liste dû à l'ajout / suppression d'une PJ
            refresh: this.needRefreshAfterPjChanged,

            //Rechargement des alertes si le contrôle sur la PJ obligatoire a changé
            refreshAlertsAndSyncWF: this.isTypePjTouched || (this.data.frais.prestation?.pieceJointeObligatoire && this.wasPjValid !== this.isPJValid())
        };
    }

    /** Référence vers l'objet DOM de l'overlay global présent lorsque la popin est ouverte */
    globalOverlay: HTMLElement;

    /** Paramètres pour le lieu départ */
    lieuParamDepart: LieuParamFrais;

    /** Paramètres pour le lieu arrivée */
    lieuParamArrivee: LieuParamFrais;

     /** Paramètre pour afficher ou non le champ frais carte */
    isFraisCarteVisible: boolean = false;

    /** Tooltip pour afficher le montant restant du frais carte */
    tooltipValeurFraisCarte: string = "";

    /** Indicateur de déplafonnement */
    deplaf: boolean;

    /** Contenu du tooltip de la date */
    dateTooltipContent: String = "";

    /** Paramètres de pièces jointes */
    pieceJointeParams: PieceJointeParam;

    /** Types de documents */
    typesDocument: TypeDocument[];

    /** Nombre d'enregistrements en cours pour les pièces jointes */
    countSavingTypePieceJointe: number = 0;

    /** Contexte de la pièce jointe */
    get contexte(): string { return this.isFrais() ? ContextDocument.FRAIS : ContextDocument.NDF_V; }

    /** Map pour stockage temporaire des types de pièces jointes */
    bufferMapForTypePiecesJointes: Map<number, TypeDocument> = new Map<number, TypeDocument>();

    /**
     * Constructeur
     */
    constructor(private ndfService: NDFService,
                private store: Store<AppState>,
                private datePipe: DatePipe,
                private toastrService: ToastrService,
                private translateService: TranslateService,
                private confirmService: ConfirmService,
                public fraisService: FraisService,
                private odService: ODService,
                private tourneeService: TourneeService,
                private adressService: AdresseService,
                private documentService: DocumentService,
                private matDialogRef: MatDialogRef<NDFFraisAddComponent,{ refresh: boolean,message?: string,refreshAlertsAndSyncWF?: boolean }>,
                private matDialog: MatDialog,
                private renderer: Renderer2,
                public fraisTaxeService: FraisTaxeService,
                private http: HttpClient,
                private pieceJointeUserService: PieceJointeUserService,
                @Inject(MAT_DIALOG_DATA) public data: { frais: any,ndf: Ndf,settings: SettingsNFState,canModifier: boolean }) {
    }

    /**
     * Initialisation
     */
    ngOnInit() {
        //Chargement des paramètres du lieu
        this.lieuParamDepart = new LieuParamFrais(this.data.ndf.idNDF,this.data.ndf.idUser);
        this.lieuParamArrivee = new LieuParamFrais(this.data.ndf.idNDF,this.data.ndf.idUser);
        this.lieuParamArrivee.placeHolder = (libelleAdresse: String,isDisabled: boolean) => "ndf.frais.arrivee";

        if (this.data.frais.idDepense || this.data.frais.idFrais) {
            //Chargement
            this.isLoading = true;

            //Si on a une devise spécifique pour le frais, on l'initialise sur l'objet frais
            if (this.data.frais.deviseCodeFrais != null) {
                this.data.frais.operation.devise = {
                    code: this.data.frais.deviseCodeFrais
                }
            }

            //Initialisation de l'onglet initial
            this.matTabGroup.selectedIndex = this.currentTab;

            //On s'assure que la liste des documents en attente est vide
            this.documentService.listeDocumentToLink.splice(0);

            //On fait deux appels
            forkJoin({
                deplaf: this.ndfService.loadDeplaf(this.data.ndf.idNDF),
                depenseFrais: this.ndfService.loadDepenseFrais(this.data.frais).pipe(first())
            }).pipe(
                finalize(() => this.isLoading = false)
            ).subscribe({
                next: (result) => {
                    //Traitement de deplaf
                    this.deplaf = result.deplaf.data.deplaf;

                    //Vérification du chargement
                    if (result.depenseFrais.codeErreur == TypeCodeErreur.NO_ERROR) {
                        //Copie de l'objet chargé dans celui déjà initialisé
                        Object.assign(this.data.frais,result.depenseFrais.data.depenseFrais);

                        //On met à jour le cours pour le calcul du forfait et cumul
                        //On ne peut pas directement utiliser le taux de l'opération, car celui-ci n'est pas forcément le taux à partir de la devise entreprise
                        //Alors que le montant du forfait est de la devise entreprise
                        this.updateCoursTaux(this.data.frais.operation.devise.code);

                        //Chargement des référentiels et autres données du formulaire
                        this.loadOnInit();
                    } else {
                        //Message d'erreur
                        this.toastrService.error(this.translateService.instant('global.errors.chargement'));

                        //Fermeture de l'écran
                        this.matDialogRef.close({refresh: false});
                    }
                },
                error: () => {
                    //Message d'erreur
                    this.toastrService.error(this.translateService.instant('global.errors.chargement'));

                    //Fermeture de l'écran
                    this.matDialogRef.close({refresh: false});
                }
            });
        } else {
            //En création, chargement des référentiels et autres données du formulaire
            this.loadOnInit();

            //Récupération du deplaf
            this.ndfService.loadDeplaf(this.data.ndf.idNDF).pipe(first()).subscribe((result) => {
                //Traitement de deplaf
                this.deplaf = result.data.deplaf;

                //Flag de chargement
                this.isLoading = false;
            });
        }

        //On récupère la saisie des temps
        if (this.data.ndf?.od != null) {
            this.odService.loadSaisieTemps(this.data.ndf.od.idOd,false).subscribe((saisie) => {
                this.saisieTemps = saisie;
            });
        }

        //Appel pour vérifier si on affiche le champ frais carte
        this.checkIsFraisCarteVisible();

        //Mise à jour du tooltip du frais carte
        this.miseAJourTooltip();

        //Fin de l'enregistrement systématique lors de la fermeture de la popin
        this.matDialogRef.afterClosed().pipe(first()).subscribe(() => this.isSaving = false);

        //Sélection du paramétrage des NDF
        this.store.select(state => state.settings?.[TypePortee.NF]).pipe(filterFirstNotNull()).subscribe((wfoSettings: SettingsWFObjectState) => {
            //Mise à jour des paramètres de pièces jointes pour la portée locale
            this.pieceJointeParams = wfoSettings.pieceJointeParams;

            //Mise à jour des types de documents
            this.typesDocument = wfoSettings.typesDocument || [];
        });
    }

    /**
     * Après l'initialisation de la vue
     */
    ngAfterViewChecked(): void {
        //Permet de positionner l'indicateur du matTabGroup sur l'onglet sélectionné
        this.matTabGroup.realignInkBar();
    }

    /**
     * Chargement des référentiels et autres données du formulaire
     */
    private loadOnInit() {
        let ville: Ville;
        let pays: Pays;
        let mission: Od | Omp;

        //Récupération de l'overlay global présent lorsque la popin est ouverte
        this.globalOverlay = this.renderer.selectRootElement('.cdk-global-overlay-wrapper', true);

        //Chargement du type entité avec les paramètres de la portée de l'objet
        this.store.dispatch({
            type: typeEntiteActions.FIND_TYPE_ENTITE,
            payload: {
                idTypeEntite: this.data.ndf.typeEntite.idTypeEntite,
                portee: TypePortee.NF
            }
        });

        //Récupération de l'utilisateur connecté
        this.store.select(state => state.session.user).pipe(first()).subscribe(user => this.user = user);

        //Récupération du type entité
        this.store.select(state => state.typeEntite[TypePortee.NF])
            //On prend le premier tel que non null
            .pipe(first((value => !!value)))
            .subscribe(typeEntite => {
                //Récupération du type entité
                this.typeEntite = typeEntite;

                //Construction de la liste des types de lieu autorisés
                if (typeEntite.typeEntiteParam) {
                    this.listeTypeGeo = !typeEntite.typeEntiteParam.gestionVilleNF ? [TypeGeographie.PAYS]
                        : typeEntite.typeEntiteParam.villeObligatoireNF ? [TypeGeographie.VILLE]
                        : [TypeGeographie.PAYS,TypeGeographie.VILLE];
                }

                //En création, initialisation de la géographie avec les paramètres du type entité ou de l'OM/OMP parent
                if (!this.data.frais.idDepense) {
                    //Type entité configuré avec une ville / un pays par défaut
                    if (typeEntite.typeEntiteParam?.lieuDepense == LieuDepense.LIEU_DEPENSE_DEFAUT) {
                        //Vérification de la ville par défaut
                        if (typeEntite.typeEntiteParam.villeDefault) {
                            //Récupération de la ville par défaut
                            ville = typeEntite.typeEntiteParam.villeDefault;
                        //Vérification du pays par défaut
                        } else if (typeEntite.typeEntiteParam.paysDefault) {
                            //Récupération du pays par défaut
                            pays = typeEntite.typeEntiteParam.paysDefault;
                        }
                    //Type entité configuré pour initialisation du lieu avec la destination principale de la mission
                    } else if (typeEntite.typeEntiteParam?.lieuDepense == LieuDepense.LIEU_DEPENSE_OM) {
                        //Récupération de la mission indistinctement du type OD / OMP
                        mission = this.data.ndf.od ?? this.data.ndf.omPermanent;

                        //Vérification de la ville sur la mission
                        if (mission?.ville) {
                            //Récupération de la ville de la mission
                            ville = mission?.ville;
                        //Vérification du pays sur la mission
                        } else if (mission?.pays) {
                            //Récupération du pays de la mission
                            pays = mission?.pays;
                        }
                    }

                    //Vérification de la ville ou du pays pour initialisation du lieu
                    if (!!ville || !!pays) {
                        //Initialisation du lieu
                        this.data.frais.geographie = {
                            id: ville ? ville.idVille : pays?.idPays,
                            type: ville ? TypeGeographie.VILLE : pays ? TypeGeographie.PAYS : null,
                            libelle: ville ? ville.libelle : pays?.libelle,
                            ville: ville,
                            pays: ville ? ville.pays : pays,
                            regionAdmin: ville ? ville.regionAdmin : null,
                            departementAdmin: ville ? ville.departementAdmin : null,
                        } as GeographieView;
                    }
                }
            });

        //Vérification de la présence d'une IJ
        this.isIJ = this.data.frais.numIndemnite != 0;

        //Met à jour isIk
        this.updateIsIk(this.data.frais.prestation);

        //Edition d'une dépense existante ou d'un frais
        if (this.data.frais.idDepense > 0 || this.data.frais.idFrais > 0) {
            //Le pays est récupéré sur la dépense ou sur le frais
            const currentPays = this.data.frais.operation?.pays ?? this.data.frais?.paysFrais;

            //Définition de la géographie
            this.data.frais.geographie = (this.data.frais.ville?.idVille || currentPays?.idPays) && {
                id: this.data.frais.ville?.idVille || currentPays?.idPays,
                type: this.data.frais.ville && TypeGeographie.VILLE || currentPays && TypeGeographie.PAYS,
                libelle: this.data.frais.ville?.libelle || currentPays?.libelle,
                ville: this.data.frais.ville,
                pays: currentPays,
                regionAdmin: this.data.frais.ville ? this.data.frais.ville.regionAdmin : null,
                departementAdmin: this.data.frais.ville ? this.data.frais.ville.departementAdmin : null,
            };
        }

        //Définition de la présence d'un justificatif
        this.data.frais.isJustificatif = this.data.frais.justificatif?.numJustificatif > 0;
        this.data.frais.previousNumJustificatif = this.data.frais.isJustificatif && this.data.frais.justificatif.numJustificatif || null;

        //Ecoute de la saisie
        this.listeSouscriptions.push(
            //Souscription pour observer la nécessité de mettre à jour la combo de sélection des indemnités
            this.store.select(state => state.saisie).subscribe((saisieState) => {
                let prestTaux: PrestTaux;

                //Récupération de l'état courant des informations de saisie
                this.saisieState = saisieState;

                //Vérification de la présence des informations requises
                if (this.saisieState?.tauxPrestation) {
                    //Si le frais est associé à une indemnité (objet FraisMission) on recherche le taux (objet PrestTaux)
                    //Sinon sélection de l'indemnité par défaut
                    prestTaux = this.findTaux(this.data.frais.taux ? this.data.frais.taux.idTaux : 0);

                    //Si on n'a pas trouvé de taux, c'est que l'ancien taux n'est plus valide (changement de pays par exemple alors qu'on a la prestation)
                    if (prestTaux == null) {
                        //On applique une valeur par défaut pour ne pas avoir le champ indemnité vide
                        prestTaux = this.saisieState?.tauxPrestation?.allTaux?.find(value => value.libelleSpecial == null || value.libelleSpecial == '');
                    }

                    //Dans le cas des IJ
                    if (this.isIJ) {
                        //Récupération de l'indemnité associée ou celle par défaut
                        this.indemniteIJ = prestTaux;
                    } else if (prestTaux) {
                        this.data.frais.taux = this.fraisService.prestTauxToFraisMission(prestTaux);

                        //On a un nouveau taux on met à jour le montant
                        this.updateMontant();
                    }
                }

                //Mise à jour du cumul
                this.updateCumul();
            })
        );

        //Mise à jour du taux de prestation
        this.refreshTauxPrestation();

        //Rafraichissement de la taxe liée à la prestation
        this.refreshTaxeForPrestation();

        //Initialisation du montant unitaire
        this.montantUnitaire = this.data.frais.ftaux || 0;

        //Initialisation de la liste des participants avec des instances de la classe
        this.listeParticipants = this.data.frais.listeParticipants = this.data.frais.listeParticipants?.map(lien => new LienParticipant(lien)) ?? [];

        //Ajout de la souscription à la liste pour être supprimée lors de la destruction du composant
        this.listeSouscriptions.push(
            //Souscription à l'évènement de validation des participants dans la popin
            this.eventSaveParticipant.subscribe((listeParticipantsFromPopin: Array<LienParticipant>) => {
                //Vidage de la liste
                this.listeParticipants.splice(0);

                //Ajout des participants à la liste
                this.listeParticipants.push(...listeParticipantsFromPopin);
            })
        );

        //Chargement des documents en attente de lien
        this.initFraisPendingDocumentToLink();

        //Pour un frais ocr il faut forcer la saisie du justificatif
        if (this.data.frais.idFrais > 0) {
            this.onJustificatifChange(true);
            this.data.frais.isJustificatif = true;
        }

        //Si la dépense contient un véhicule
        if (this.data.frais.vehicule) {
            //On le rattache à la prestation qu'elle contient
            this.data.frais.prestation.vehicule = this.data.frais.vehicule;
        }

        //On initialise la valeur saisie avant modification
        this.montantInit = this.data.frais.montant;

        //On initialise la valeur liée a l'opcarte avant modification
        if (this.data.frais.operation.opeCarte){
            this.montantInitLieOpCarte = this.data.frais.montant;
        }

        //Récupération de l'état de validité sur le nombre de PJ au chargement
        this.wasPjValid = !this.data.frais.prestation?.pieceJointeObligatoire || this.getNbDocuments() > 0;

        //Affichage de la zone d'upload le cas échéant
        this.checkDocUploaderVisibility();

        //Transformation de la date en objet moment pour le date picker
        if (this.data.frais.date) {
            this.data.frais.date = moment(this.data.frais.date);
        }

        //Initialisation du champ allerRetour
        if (this.data.frais.allerRetour === undefined) {
            this.data.frais.allerRetour = null;
        }

        //Initialisation du champ collaborateurAbsent
        if (this.data.frais.collaborateurAbsent === undefined) {
            this.data.frais.collaborateurAbsent = null;
        }
    }

    /**
     * Destruction du composant
     */
    ngOnDestroy() {
        //Suppression des souscriptions
        this.listeSouscriptions.forEach(s => s.unsubscribe());
    }

    /**
     * Activation de la présence d'un justificatif
     */
    onJustificatifChange(checked: boolean) {
        //Vérification de l'état de la case à cocher
        if (checked && !this.data.frais.justificatif?.numJustificatif) {
            //Vérification de l'existence d'un numéro de justificatif précédent
            if (this.data.frais.previousNumJustificatif) {
                //Rétablissement du numéro de justificatif
                this.data.frais.justificatif.numJustificatif = this.data.frais.previousNumJustificatif;
            } else {
                //Chargement du dernier numéro de justificatif pour la note de frais
                this.ndfService.getLastNumJustificatif(this.data.ndf.idNDF).pipe(first()).subscribe(numJustificatif => {
                    //Mise à jour du numéro de justificatif si nécessaire
                    this.data.frais.justificatif.numJustificatif = numJustificatif;
                });
            }
        } else if (!checked && this.data.frais.justificatif?.numJustificatif) {
            //Retrait du justificatif
            this.data.frais.justificatif = {};

            //Annulation de la saisie d'un justificatif
            this.data.frais.isJustificatif = false;
        }
    }

    /**
     * Changement de lieu de départ ou d'arrivée
     */
    onDepartArriveeChange(event: any) {
        //Calcul de la distance (si possible)
        this.updateDistance();

        //On a changé l'adresse, on peut afficher le bouton retenir projet
        this.canShowRetenirTrajet = true;

    }

    /**
     * Activation du mode Aller/Retour pour le calcul des distances
     */
    onAllerRetourChange(checked: boolean) {
        //Si on ne peut pas afficher 'retenir trajet', on est sur un trajet sélectionné
        if (!this.canShowRetenirTrajet) {
            //Ce sont des données de trajet, on recalcule à la main pour ne pas modifier le calcul
            if (checked) {
                this.data.frais.quantite = this.data.frais.quantite * 2;
            } else {
                this.data.frais.quantite = this.data.frais.quantite / 2;
            }
            //Recalcul du montant après changement de quantité
            this.onQuantiteChange();
        } else {
            //On est sur des localisations saisies on lance le calcul
            this.isComputingDistance = true;
            this.fraisService.findDistance(this.data.frais.localisationDepart,this.data.frais.localisationArrivee,checked).pipe(
                catchError(() => of(null))
            ).subscribe({
                next: distance => {
                    if (distance != null) {
                        //Mise à jour de la quantité et recalcul du montant
                        this.data.frais.quantite = distance;
                        this.onQuantiteChange();
                    }
                    this.isComputingDistance = false;
                }
            });
        }
    }

    /**
     * Mise à jour du tooltip sur le montant restant de la carte frais
     */
    miseAJourTooltip() {
        //Si un frais carte est renseigné
        if (this.data.frais.operation.opeCarte) {
            //Formatage du montant
            const montantFormat = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: this.data.frais.operation.opeCarte.deviseAchat
            }).format(this.data.frais.operation.opeCarte.montantRestant);

            //Mise à jour du tooltip
            this.tooltipValeurFraisCarte = this.data.frais.operation?.opeCarte?.montantRestant ?
                this.translateService.instant('ndf.frais.fraisCarte.toolTipMontantRestant', {
                    montantRestant: montantFormat
                }) : '';
        }
    }

    /**
     * Changement de frais carte
     */
    onFraisCarteChange() {
        //Initialisation de la géographie
        if (!this.data.frais.geographie) {
            this.data.frais.geographie = {};
        }

        //Mise à jour du pays
        if (!this.data.frais.geographie.pays && this.data.frais.operation?.opeCarte?.pays) {
            this.data.frais.geographie.pays = this.data.frais.operation.opeCarte.pays;
            this.data.frais.pays = this.data.frais.operation.opeCarte.pays;
        }

        //Mise à jour de la date d'achat
        if (!this.data.frais.date) {
            this.data.frais.date = this.data.frais.operation.opeCarte.dateVente;
        }

        //Mise à jour du montant de l'achat
        if (!this.data.frais.montant) {
            this.data.frais.montant = this.data.frais.operation.opeCarte.montantRestant;
        }

        //Mise à jour de la quantité
        this.data.frais.quantite = 1;

        //Mise à jour du tooltip
        this.miseAJourTooltip();

        //Si le justificatif n'a pas de libellé
        if(!this.data.frais.justificatif.libelle) {
            //Mise à jour du justificatif
            this.onJustificatifChange(true);
            this.data.frais.isJustificatif = true;
            this.data.frais.justificatif.libelle = this.data.frais.operation.opeCarte.enseigne;
        }

        //Si une prestation est renseignée
        if (this.data.frais.operation.opeCarte.prestation) {
            //Mise à jour de la prestation
            this.data.frais.prestation = this.data.frais.operation.opeCarte.prestation;
        }

        //Rafraichissement du taux de prestation (la prestation, le pays et la date ont pu être modifiés programmatiquement sans déclencher leurs événements de changement)
        this.refreshTauxPrestation();
    }

    /**
     * Changement de prestation
     */
    onPrestationChange() {
        const prestation = this.data.frais.prestation;

        //Contrôle de la prestation par rapport au pays
        if (prestation?.idPays > 0 && this.data.frais.geographie?.pays && prestation.idPays != this.data.frais.geographie?.pays.idPays) {
            this.data.frais.geographie = null;
        }

        //Reset de l'erreur de fréquence
        this.hasFrequenceAutoriseeError = false;

        //Reset du bloquage quantité
        this.isQuantiteBlockedByAdminTrajet = false;

        //Reset de l'indemnité
        this.data.frais.taux = null;

        //Reset du montant si l'ancienne ou si la nouvelle prestation est une ik
        if (this.isIk || prestation?.bareme) {
            this.data.frais.montant = null;
        }

        //Reset de la tournée
        delete this.data.frais.tournee;

        //Si l'ancienne prestation est une IK mais pas la nouvelle
        if (this.isIk && (prestation == null || !prestation.bareme)) {
            //On supprime les localisations
            delete this.data.frais.localisationDepart;
            delete this.data.frais.localisationArrivee;
        }

        //Et on met à jour la variable isIk avec la nouvelle prestation
        this.updateIsIk(prestation);

        //Mise à jour de la quantité
        this.fraisService.onPrestationChangeUpdateQuantite(prestation,this.data.frais);

        //Vérification du type de prestation pour retirer le justificatif
        if (prestation?.type == TypePrestation.FORFAIT && !prestation?.justificatifOBligatoire && !prestation?.justificatifDefaut) {
            //Retrait du justificatif
            this.data.frais.justificatif = {};

            //Annulation de la saisie d'un justificatif
            this.data.frais.isJustificatif = false;
        }

        //Vérification de la présence d'un justificatif par défaut
        if (prestation?.justificatifDefaut) {
            //Saisie par défaut d'un justificatif
            this.data.frais.isJustificatif = true;

            //Mise à jour du numéro de justificatif
            this.onJustificatifChange(true);
        }

        //Initialisation du nombre d'invités externes à 0 dans le cas où le référentiel est désactivé
        if (prestation?.genre == Genre.RECEPTION && !this.data.settings.isReferentielParticipantsExternes && !this.data.frais.nbInvites) {
            this.data.frais.nbInvites = 0;
        }

        //Initialisation du montant unitaire
        this.montantUnitaire = this.data.frais.prestation?.montant;

        //Si la prestation comporte un véhicule
        if (prestation?.vehicule) {
            //On le rattache au frais
            this.data.frais.vehicule = prestation.vehicule;
        } else {
            //On le supprime s'il y en avait un
            delete this.data.frais.vehicule;
        }

        //Rafraichissement du taux de prestation si nécessaire
        this.refreshTauxPrestation();

        //Rafraichissement de la taxe liée à la prestation
        this.refreshTaxeForPrestation();

        //Rafraichissement de la zone utilisateur
        this.refreshZoneUtilisateur();
    }

    /**
     * Changement de géographie
     */
    onGeographieChange() {
        //Rafraichissement du taux de prestation si nécessaire
        this.refreshTauxPrestation();

        //Rafraichissement de la taxe liée à la prestation
        this.refreshTaxeForPrestation();

        //On contrôle la validité de la prestation déjà saisie
        if (this.data.frais.prestation != null && this.data.frais.prestation.idPrestation !== 0) {
            this.fraisService.findPrestation(
                this.data.frais.pays?.idPays || this.data.frais.geographie?.pays?.idPays,
                this.data.ndf.typeEntite.idTypeEntite,
                TypePortee.NF,
                this.data.ndf.idNDF,
                this.data.frais.prestation.idPrestation).subscribe( (page: Page<Prestation>)=> {
                //Si on n'a pas de résultat c'est que la prestation n'est pas valide
                if (page.listeResultats.length === 0) {
                    //On supprime la prestation
                    delete this.data.frais.prestation;
                }
            });
        }

        //Adaptation de la devise au pays sélectionné
        const codeDevisePays = this.data.frais.geographie?.pays?.devise;
        if (codeDevisePays) {
            //Vérification que la devise du pays est dans la liste des devises autorisées
            const deviseFound = this.data.settings.listeDevises.find(dev => dev.code === codeDevisePays);
            if (deviseFound && this.data.frais.operation?.devise?.code !== codeDevisePays) {
                //Mise à jour du frais avec la devise sélectionnée
                this.data.frais.operation.devise = deviseFound;

                //Mise à jour du cours et recalcul du montant forfait
                this.fraisService.findCoursForDevise(
                    codeDevisePays,
                    this.data.frais.date,
                    this.data.settings.deviseEntreprise,
                    1
                ).subscribe(cours => {
                    this.coursTaux = cours;
                    this.updateCumul();

                    //Recalcul du montant forfait avec le nouveau cours
                    if (this.data.frais.prestation?.type === TypePrestation.FORFAIT && !this.data.frais.prestation?.bareme) {
                        this.data.frais.montant = this.getMontantForfait();
                    }
                });
            }
        }
    }

    /**
     * Fonction appelée à la modification de la quantité
     */
    onQuantiteChange(): void {
        //Dans le cas d'une prestation de type barème
        if (this.data.frais.prestation?.bareme) {
            //On supprime le montant du frais. Il sera calculé à l'enregistrement
            delete this.data.frais.montant;
        }

        //On change la quantité on met à jour le montant
        this.updateMontant();
    }

    /**
     * Mise à jour du montant
     */
    updateMontant(): void {
        //Cas d'une prestation de type forfait (hors barème, car dans ce cas le calcul est fait côté back)
        if (this.data.frais.prestation?.type !== TypePrestation.FORFAIT || this.data.frais.prestation?.bareme) {
            return;
        }

        const isDistanceNonBareme = [TypeDistance.TYPE_DISTANCE_KM,TypeDistance.TYPE_DISTANCE_MILES]
            .includes(this.data.frais.prestation?.unite?.typeDistance);

        if (isDistanceNonBareme) {
            //Cas IK non barème : recalcul systématique à chaque changement de quantité (aller-retour inclus)
            //mais uniquement quand le taux est chargé pour éviter un écrasement à 0 temporaire
            const hasTauxLoaded = !!this.saisieState?.tauxPrestation?.taux || !!this.saisieState?.tauxPrestation?.allTaux?.length;
            if (!hasTauxLoaded) {
                return;
            }
            this.data.frais.montant = this.getMontantForfait();
        } else if (this.data.frais.montant == null || this.data.frais.montant == 0) {
            //Cas forfait non distance : comportement historique, ne recalculer que si montant absent
            this.data.frais.montant = this.getMontantForfait();
        }
    }

    /**
     * Retourne le montant calculé d'une prestation de type forfait.
     * Si la prestation n'est pas de ce type, retourne undefined.
     */
    getMontantForfait(): number {
         //Vérification de la présence d'une IJ
         if (this.isIJ) {
            //Retour de la valeur calculé automatiquement lors de la création de l'IJ
            return this.fraisService.getValueAsNumber(this.montantUnitaire);
        } else if (this.data.frais.prestation?.type == TypePrestation.FORFAIT) {
            //Vérification du type de prestation Forfait
            //Si c'est une prestation de type barème
            if (this.data.frais.prestation?.bareme) {
                //On renvoie le montant s'il a déjà été calculé ou zéro
                return this.data.frais.montant ?? 0;
            } else {
                //Calcul
                return (this.fraisService.getValueAsNumber(this.data.frais.quantite) || 0) * (this.getTauxForPrestation() || 0);
            }
        } else {
            return undefined;
        }
    }

    /**
     * Fonction d'ouverture de la popup de détail du calcul d'une IK
     */
    viewDetailCalculIk(): void {
        //Ouverture de la popup
        this.matDialog.open(PopupDetailCalculIkComponent,{
            data: {
                idDepense: this.data.frais.idDepense,
                idVehicule: this.data.frais.vehicule.idPa
            }
        });
    }

    /**
     * Handler du bouton enregistrer
     */
    onSave() {
        //Si on a une seule taxe et qu'on peut modifier le frais mais pas la taxe
        if (this.fraisTaxeService.isShowTaxe() && !this.fraisTaxeService.isMultiTaux() && this.data.canModifier && !this.fraisTaxeService.canModifierMontantTaxe()) {
            //On initialise le montant à 0 si on n'a aucune valeur
            this.fraisTaxeService.initTaxeMontantsIfNull(this.data.frais);
        }

        //Si on doit retenir le trajet, on ouvre une popin pour le changement de nom
        if (this.isRetenirTrajet) {
            const formatedLibelle = this.adressService.getVilleFromAdress(this.data.frais.localisationDepart)
                + ' / ' + this.adressService.getVilleFromAdress(this.data.frais.localisationArrivee);

            this.matDialog.open(TrajetRenommerComponent,{
                minWidth: '700px',
                data: {
                    libelle: formatedLibelle
                },
            }).afterClosed().subscribe((libelle: string) => {
                //Si on a un libellé saisi, c'est que l'user n'a pas annulé
                if (!!libelle) {
                    //On sauvegarde
                    this.saveDepense(libelle)
                }
            });
        } else {
            //On sauvegarde directement
            this.saveDepense()
        }
    }

    /**
     * Enregistrement effectif des types de PJ en attente
     */
    async savePendingTypesPiecesJointes(): Promise<void> {
        return new Promise(async resolve => {
            //Si la map dédiée contient des types à sauvegarder
            if (!!this.bufferMapForTypePiecesJointes.size) {
                //Parcours de la map
                for (const idDocument of this.bufferMapForTypePiecesJointes.keys()) {
                    //Sauvegarde du type de PJ
                    await this.saveTypePieceJointe(idDocument, this.bufferMapForTypePiecesJointes.get(idDocument), null);

                    //Suppression de la map
                    this.bufferMapForTypePiecesJointes.delete(idDocument);
                }
            }

            //Fin de la promesse
            resolve();
        });
    }

    /**
     * Enregistrement de la dépense
     */
    saveDepense(libelleTrajet: string = null) {
        //Enregistrement en cours
        this.isSaving = true;

        //Blocage de la sauvegarde tant que le calcul de distance est en cours
        if (this.isComputingDistance) {
            this.toastrService.warning(this.translateService.instant('ndf.frais.info.calculDistanceEnCours'));
            this.isSaving = false;
            return;
        }

        //Contrôle la validité des champs, bloque la sauvegarde si ce n'est pas le cas.
        if (!this.isValid()) {
            this.toastrService.error(this.translateService.instant('global.errors.formInvalid'));
            this.isSaving = false;
            return;
        }

        //Reset de l'erreur de fréquence
        this.hasFrequenceAutoriseeError = false;

        //Mise à jour du pays et de la ville
        if (!this.data.frais.operation.opeCarte || this.data.frais.geographie?.pays) {
            this.data.frais.operation.pays = this.data.frais.geographie.pays;
            this.data.frais.ville = this.data.frais.geographie.ville || null;
        }

        //Si on a un frais carte
        if (this.data.frais.operation.opeCarte){
            //Le montant doit être inférieur ou égal au montant restant du frais carte
            if (this.data.frais.montant > (this.data.frais.operation.opeCarte.montantRestant + this.montantInitLieOpCarte)){
                //Message d'erreur
                this.toastrService.error(this.translateService.instant('ndf.frais.erreur.montantSuperieurFraisCarte'));

                //Annulation de l'enregistrement
                this.isSaving = false;
                return;
            }
        }

        //Mise à jour de la taxe de la dépense
        this.data.frais.saisieTaxe = this.data.frais.saisieTaxe && {
            ...this.data.frais.saisieTaxe,
            updateMontants: true,
        } || null;

        //On met à jour les ZU avant la sauvegarde si on a des ZU
        if (this.childZoneUtilisateurComponent) {
            //Pour éviter une nouvelle référence qui crée un clignotement des cases à cocher sur l'UI, on passe par une variable temporaire
            //Cela revient à faire this.data.frais.listeZU = this.childZoneUtilisateurComponent.getListeZoneUtilisateursBeforeSave();
            const newListeZU = this.childZoneUtilisateurComponent.getListeZoneUtilisateursBeforeSave();
            //Initialisation de la liste des zones utilisateurs si elle n'est pas définie
            if (!this.data.frais.listeZU) {
                this.data.frais.listeZU = [];
            }
            //On réinitialise la listeZU
            this.data.frais.listeZU.length = 0;
            //Et on ajoute les valeurs dans le tableau qui a été réinitialisé
            this.data.frais.listeZU.push(...newListeZU);
        }

        //On supprime le véhicule de la prestation pour ne pas avoir d'erreur de désérialisation (le véhicule étant stocké dans la dépense directement)
        if (this.data.frais.prestation.vehicule) {
            delete this.data.frais.prestation.vehicule;
        }

        //Reset du nbInvites quand le référentiel est actif (le backend calculera à partir de la liste des participants)
        if (this.data.settings.isReferentielParticipantsExternes) {
            this.data.frais.nbInvites = 0;
        }

        //Enregistrement de la dépense
        this.ndfService.saveDepense(this.data.ndf.idNDF,this.data.frais,this.data.frais.idFrais,libelleTrajet)
            .pipe(first())
            .subscribe({
                next: async data => {
                    //Vérification de l'enregistrement
                    if (data.depense) {
                        //Mise à jour des montants de la NDF
                        this.data.ndf.montantDepenses = data.montantDepense;
                        this.data.ndf.montantRemboursable = data.montantRemboursable;
                        this.data.ndf.montantARembourser = data.montantARembourser;

                        //S'il y a des documents en attente de liaison avec l'objet
                        if (this.documentService?.hasPendingDocumentToLink()) {
                            const observables = [];
                            //Association des documents en attente avec l'objet
                            observables.push(this.documentService.linkAllPendingDocument(data.depense.idDepense,ContextDocument.NDF_V));

                            const justificatifs: Document[] = this.documentService.listeDocumentToLink;

                            if(justificatifs.length > 0) {
                                //Si on a des justificatifs à envoyer
                                //Appel pour traiter les justificatifs avec l'id dépense
                                observables.push(this.ndfService.processJustificatif(justificatifs,false,this.data.ndf.idNDF,data.depense.idDepense));
                            }

                            forkJoin(observables).subscribe(async (res) => {
                                //Vérification du succès de l'opération
                                //On ne contrôle pas l'intégration des justificatifs, car sur cet écran, on peut enregistrer des documents qui ne sont pas scannable par l'ocr
                                if (res[0]) {
                                    //Sauvegarde des types de PJ en attente
                                    await this.savePendingTypesPiecesJointes();

                                    //Fermeture de l'écran
                                    this.matDialogRef.close({refresh: data != null || this.needRefreshAfterPjChanged});
                                } else {
                                    //Message d'erreur
                                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                                }
                            });
                        } else {
                            //Sauvegarde des types de PJ en attente
                            await this.savePendingTypesPiecesJointes();

                            //Fermeture de l'écran
                            this.matDialogRef.close({refresh: data != null || this.needRefreshAfterPjChanged});
                        }
                    } else {
                        if (!data.codeErreur) {
                            //Message d'erreur générique
                            this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_PERIODE) {
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.periode'));
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_OM_DATE) {
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.omDate'));
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_QUANTITE_AUTORISEE ) {
                            //On récupère la fréquence
                            const frequenceAutorisee = this.data.frais.prestation.frequenceAutorisee;

                            //On change le libellé de la période
                            let periode = frequenceAutorisee == FrequenceAutorisee.JOUR
                                ? 'ndf.frais.erreur.quantiteJ'
                                : frequenceAutorisee == FrequenceAutorisee.SEMAINE
                                    ? 'ndf.frais.erreur.quantiteS'
                                    : frequenceAutorisee == FrequenceAutorisee.ANNEE
                                        ? 'ndf.frais.erreur.quantiteA'
                                        : 'ndf.frais.erreur.quantiteM';
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.quantite') + this.translateService.instant(periode));

                            this.hasFrequenceAutoriseeError = true;
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_MONTANT_NEGATIF) {
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.montantNegatif'));
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_DEPENSE_FUTURE) {
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.depenseFuture'));
                        } else if (data.codeErreur == FraisErreur.ANOMALIE_OM_PERMANENT_DATE) {
                            //Affichage du message d'erreur
                            this.toastrService.error(this.translateService.instant('ndf.frais.erreur.omPermanentDate'));
                        } else {
                            //Message d'erreur
                            this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                        }
                        //Fin de l'enregistrement
                        this.isSaving = false;
                    }
                },
                error: () => {
                    //Message d'erreur
                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                    //Fin de l'enregistrement
                    this.isSaving = false;
                }
        });
    }

    /**
     * Suppression de la dépense
     */
    deleteDepense() {
        //Message de confirmation
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation')).pipe(filter(isConfirmed => isConfirmed)).subscribe({
            next: () => {
                //Suppression en cours
                this.isDeleting = true;

                //Si on est sur une dépense
                if (this.data.frais.idDepense) {
                    //Suppression de la dépense
                    this.ndfService.deleteDepense(this.data.ndf.idNDF,this.data.frais.idDepense).pipe(first(),finalize(() => {
                        this.isDeleting = false;
                    })).subscribe({
                        next: result => {
                            //Vérification de l'enregistrement
                            if (result.codeErreur == TypeCodeErreur.NO_ERROR) {
                                //Mise à jour des montants de la NDF
                                this.data.ndf.montantDepenses = result.data.montantDepense;
                                this.data.ndf.montantRemboursable = result.data.montantRemboursable;
                                this.data.ndf.montantARembourser = result.data.montantARembourser;

                                //Fermeture de l'écran
                                this.matDialogRef.close({refresh: true,message: 'global.success.suppression'});
                            } else
                                //Message d'erreur
                                this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                        }
                    });
                } else {
                    //Si on est sur un frais
                    //Suppression du link pour rebascule dans la liste globale
                    this.ndfService.unlinkFraisWithNdf(this.data.ndf.idNDF,this.data.frais.idFrais).pipe(first(),finalize(() => {
                        this.isDeleting = false;
                    })).subscribe({
                        next: result => {
                            //Vérification de l'enregistrement
                            if (result.codeErreur == TypeCodeErreur.NO_ERROR) {
                                //Fermeture de l'écran
                                this.matDialogRef.close({refresh: true,message: 'global.success.suppression'});
                            } else
                                //Message d'erreur
                                this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                        }
                    });
                }
            }
        });
    }

    /**
     * Rafraichissement du taux de prestation
     */
    refreshTauxPrestation() {
        this.fraisService.refreshTauxPrestation(
            this.data.frais.prestation,
            this.data.frais.date,
            this.data.frais.geographie?.pays,
            this.data.frais.geographie?.ville,
            this.data.ndf.idNDF
        );
    }

    /**
     * Changement de devise
     */
    onDeviseChange(codeDevise: string) {
        //Mise à jour du frais avec la devise sélectionnée
        this.data.frais.operation.devise = this.data.settings.listeDevises.find(dev => dev.code === codeDevise);
        //Mise à jour du taux associé
        this.updateCoursTaux(codeDevise);
    }

    /**
     * Mise à jour du cours du taux
     * @param codeDevise Code de la devise à mettre à jour
     * */
    updateCoursTaux(codeDevise: string) {
        //On met à jour la devise, on renseigne la devise entreprise qui est la devise de référence à un taux à 1
        this.fraisService.findCoursForDevise(
            codeDevise,
            this.data.frais.date,
            this.data.settings.deviseEntreprise,
            1
        ).subscribe(cours => {
            this.coursTaux = cours;
            this.updateCumul();
        });
    }

    /**
     * Récupération du taux de la prestation
     */
    getTauxForPrestation(): number {
        return this.fraisService.getTauxForPrestation(
            this.saisieState,
            this.data.settings,
            this.data.frais.operation?.devise?.code,
            this.coursTaux,
            this.data.frais.taux
        );
    }

    /** Met à jour le cumul */
    updateCumul(): void {
        const tauxForPrestation = this.getTauxForPrestation();

        this.cumulRestant =  this.fraisService.getCumulRestant(
            this.saisieState,
            this.data.settings,
            this.data.frais.operation?.devise?.code,
            this.coursTaux,
            tauxForPrestation,
            this.montantInit
        );
    }

    /**
     * Retourne le taux correspondant à un id.
     *
     * @param idTaux Identifiant du taux. Si vide/undefined/null, retourne le taux qui sera utilisé "par défaut"
     */
    findTaux(idTaux?: number): PrestTaux {
        return this.fraisService.findTaux(this.saisieState,idTaux);
    }

    /**
     * Vérification de la taxe saisie
     */
    isTaxeValid(): boolean {
        return this.fraisTaxeService.isTaxeValid(this.data.frais.montant,this.data.frais.saisieTaxe?.listeTaxes);
    }

    /**
     * Rafraichissement de la taxe liée à la prestation
     */
    refreshTaxeForPrestation() {
        this.fraisTaxeService.refreshTaxeForPrestation(this.data.frais);
    }

    /**
     * Calcul du montant de taxe pour un taux
     */
    computeTaxeMontant(taux) {
        //Vérification du montant
        if (!taux.montantBase) {
            //Calcul du montant
            taux.montantBase = (this.data.frais.montant || 0) * (1 - 1 / (1 + taux.taux / 100));
        } else {
            //Remise à zéro du montant
            taux.montantBase = null;
        }
    }

    /**
     * Affichages des invités
     */
    showListeParticipants() {
        //Ouverture de la popup
        this.matDialog.open(ParticipantsPopinComponent,{
            data: {
                listeParticipant: [...this.data.frais.listeParticipants], // Passage d'une copie
                idObjet: this.data.frais.idDepense ?? 0,
                idNDF: this.data.ndf.idNDF,
                idPrestation: this.data.frais.prestation?.idPrestation,
                settings: this.data.settings,
                idTypeEntite: this.data.ndf.typeEntite?.idTypeEntite,
                idUser: this.user.idUser,
                idUserObjet: this.data.ndf.idUser,
                modeParticipant: this.data.frais.prestation?.modeParticipant ?? ModeParticipants.TOUS,
                contexte: 'NDF_V',
                canModifier: this.data.canModifier,
                eventSaveParticipant: this.eventSaveParticipant
            },
            minWidth: 1000,
            maxWidth: 1200,
            maxHeight: 800
        });
    }

    /**
     * Dénombrement des invités par type
     */
    countInvitesForType(typeInvite: TypeParticipant): number {
        //Retour du nombre d'invités
        return (this.data.frais.listeParticipants as Array<LienParticipant>)?.filter(p => typeInvite == TypeParticipant.INTERNE && p.user || typeInvite == TypeParticipant.EXTERNE && p.participantExterne)?.length || 0;
    }

    /**
     * Vérifie la validité du nombre de participants si prestation "Réception", sinon retourne True
     */
    isInvitesValid(): boolean {
        return this.data.frais.prestation?.genre == Genre.RECEPTION ? this.data.frais.listeParticipants?.length + (this.data.frais.nbInvites ?? 0) + (this.data.frais.collaborateurAbsent ? 0 : 1) > 0 : true;
    }

    /**
     * Vérifie si le justificatif est présent si obligatoire
     */
    isJustifValid(): boolean {
        return !this.data.frais.prestation?.justificatifObligatoire || this.data.frais.isJustificatif;
    }

    /**
     * Vérifie si une pièce jointe est présente si obligatoire
     */
    isPJValid(): boolean {
        return !this.data.frais.prestation?.pieceJointeObligatoire || this.data.frais.listeDocuments?.length > 0;
    }

    /**
     * Vérifie si les données sont valides
     *
     * @return True si valide, False sinon
     */
    isValid(): boolean {
        //Si on n'a pas de ZU ou que les ZU sont valides
        return this.childZoneUtilisateurComponent == null || this.childZoneUtilisateurComponent.isValid();
    }

    /**
     * Rafraichissement des zones utilisateurs.
     */
    refreshZoneUtilisateur(): void {
        if (this.data.frais.prestation != null) {
            this.ndfService.loadZoneUtilisateur(this.data.ndf.idNDF, this.data.frais.prestation.idPrestation, this.data.frais.idDepense)
                .pipe(first()).subscribe(data => {
                this.data.frais.listeZU = data.listeZu;
                this.data.frais.listeZUSaisies = data.listeZUSaisies;
            });
        }
    }

    /**
     * Vérifie si le lieu de la dépense est valide et correspond au type attendu
     */
    isGeographieValid(): boolean {
        return !this.geographie?.invalid && this.listeTypeGeo.includes(this.data.frais?.geographie?.type);
    }

    /**
     * Renvoie true si l'objet est un objet frais dans le back ou false si l'objet est un objet depense dans le back
     */
    isFrais() {
        return this.data.frais.idFrais != null && this.data.frais.idFrais > 0;
    }

    /**
     * Initialisation des documents en attentes de lien
     */
    initFraisPendingDocumentToLink() {
        //Si l'objet est un frais
        if(this.isFrais()) {
            this.ndfService.loadPendingFraisDocumentToLink(this.data.frais.idFrais).pipe(first()).subscribe(
                (res) => {
                    if(res.codeErreur == TypeCodeErreur.NO_ERROR) {
                        //On ajoute les documents dans les documents en attentes de lien
                        res.data.listeDocument.data.forEach((d) => {
                            this.documentService.listeDocumentToLink.push(d);
                        })
                    }
                    else {
                        this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                    }
                }
            );
        }
    }

    /**
     * Mise à jour de l'onglet sélectionné
     */
    changeTab(tabGroup: MatTabGroup, tabIndex: NdfFraisAddTab) {
        tabGroup.selectedIndex = tabIndex;
    }

    /**
     * Mise à jour du suivi de l'onglet sélectionné
     */
    tabChanged(tabIndex: NdfFraisAddTab) {
        this.currentTab = tabIndex;
    }

    /**
     * Selection de frais dans la liste mes frais
     */
    selectMesFrais() {
        //Début du traitement
        this.isAddingToNote = true;

        //Envoi de l'évent de sélection à l'élément enfant
        this.childNDFFraisAddMesFraisComponent.select()
            .pipe(first(),finalize(() => {
                //Fin du traitement
                this.isAddingToNote = false;
                this.matDialogRef.close({refresh: true});
            }))
            .subscribe({
                next: (integrationMesFrais: IntegrationMesFrais) => {
                    //Contruction du message à afficher
                    const message = this.translateService.instant('ndf.frais.mesFrais.resutatIntegration')
                        + '<br />' + integrationMesFrais.nbDepenseOK + ' ' + this.translateService.instant('ndf.frais.mesFrais.resultatCorrect')
                        + '<br />' + integrationMesFrais.nbDepenseKO + ' ' + this.translateService.instant('ndf.frais.mesFrais.resultatAnomalie');

                    //Affichage d'un message de succès même si des anomalies sont présentes
                    this.toastrService.success(message,'', { enableHtml : true });
                },
                error: () => {
                    //Affichage d'un message d'erreur
                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                }
            });
    }

    /**
     * Rejette le frais courant
     */
    rejeterFrais(): void {
        //Ouverture du dialogue de saisie du motif
        this.matDialog.open(NDFFraisAddMotifComponent).afterClosed().subscribe({
            next: (motif: string) => {
                //Si Le motif a été validé on continue le rejet
                if (motif != null) {
                    //Le dialogue de confirmation a été validé on lance le rejet
                    this.isRejecting = true;

                    this.ndfService.rejeterFrais(this.data.ndf.idNDF, this.data.frais.idDepense, motif)
                        .pipe(first(),finalize(() => {
                            //Fin du traitement
                            this.isRejecting = false;
                            //On ne fait pas de syncroworkflow dans ce cas
                            this.matDialogRef.close({refresh: true,message: 'ndf.frais.retourRejet',refreshAlertsAndSyncWF: false});
                        }))
                        .subscribe({
                            next: (result: Result) => {
                               if (result.codeErreur === TypeCodeErreur.ERROR_PERMISSION) {
                                    //On met une erreur de permission
                                    this.toastrService.error(this.translateService.instant('global.errors.permission'));
                                } else if (result.codeErreur !== TypeCodeErreur.NO_ERROR) {
                                    //On met une erreur d'enregistrement
                                    this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                               } else {
                                   //Toast par défaut indiquant le succès de l'enregistrement
                                   this.toastrService.success(this.translateService.instant('global.success.enregistrement'));
                               }
                            },
                            error: () => {
                                this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                            }
                        })
                }
            }
        });
    }

    /**
     * Filtre les documents qui ont déjà été envoyés via le process justificatif
     *
     * @param document  Le ou les documents
     * @returns         La liste des documents
     */
    filterDocumentAndProcessJustificatif(document: Document | Document[]): Document[] {
        let listeDocuments: Array<Document>;

        //Envoi d'une liste de documents
        if (Array.isArray(document)) {
            listeDocuments = document.filter(d => d.saveFile != null);
        } else if(document.saveFile != null) {
            //Envoi d'un seul document
            listeDocuments = [document];
        }

        return listeDocuments;
    }

    /**
     * Evenement qui indique si la liste est vide
     * @param isListeEmpty indicateur qui indique si la liste est vide
     */
    onListeEmpty(isListeEmpty: boolean) {
        this.isListeEmpty = isListeEmpty;
    }

    /**
     * Renvoie true si il faut afficher le bouton ajouter note
     */
    canAjouterNote(): boolean {
        return this.isCreation() && this.currentTab == NdfFraisAddTab.mesFrais
    }

    /**
     * Renvoie true si on est en création
     */
    isCreation(): boolean {
        return !(this.data.frais.idDepense > 0 || this.data.frais.idFrais > 0)
    }

    /**
     * Dans le cas d'une prestation d'IK, on vérifie si le véhicule associé dispose d'une autorisation de circuler pour le jour de la prestation
     *
     * @return true si le véhicule n'est pas autorisé à circuler, false sinon
     */
    hasNotAutorisationCirculer(): boolean {
        return this.data.settings.isAutorisationVehiculeActif
            && this.data.settings.niveauControleAutorisationVehiculeNdf !== NiveauAutorisation.NON_CONTROLE
            && this.data.frais.date
            && this.data.frais.vehicule
            && !this.data.frais.vehicule.listeAutorisation.some(a => moment(a.dateDebut).isSameOrBefore(this.data.frais.date,'day') && moment(a.dateFin).isSameOrAfter(this.data.frais.date,'day'));
    }

    /**
     * Définit si la quantité est modifiable
     */
    isQuantiteModifiable(): boolean {
        //Si la quantité de la prestation est modifiable et pas bloqué pas l'admin trajet et qu'on n'est pas sur une tournée
        return this.data.frais.prestation?.quantiteModifiable && !this.isQuantiteBlockedByAdminTrajet && this.data.frais.tournee == null;
    }

    /**
     * Mise à jour d'isIK
     * @param prestation la prestation à controler
     */
    updateIsIk(prestation: any): void {
        //Contrôle si la prestation est une ik
        this.isIk = prestation?.bareme;
    }

    /**
     * Indique s'il faut afficher l'onglet trajet
     */
    isShowTrajets(): boolean {
        return this.data?.frais?.prestation?.geolocalisation;
    }

    /**
     * Indique s'il faut afficher la ligne de formulaire qui permet de renseigner le départ et l'arrivée du trajet
     */
    get isShowSaisieTrajets(): boolean {
        return (this.isShowTrajets() && !this.canShowTournee()) || (this.canShowTournee() && this.data.frais.tournee == null);
    }

    /**
     * Indique si la case à cocher permettant de sauvegarder le trajet est affichée
     */
    get isShowSaveTrajetCheckbox(): boolean {
        return this.canShowRetenirTrajet && this.isShowTrajets() && this.data.frais.prestation.saveTrajet;
    }

    /**
     * Indique si on doit afficher le montant hors forfait
     */
    isMontantHorsForfait(): boolean {
        return this.data.frais.prestation?.type != TypePrestation.FORFAIT || this.data.frais.prestation?.idAppTva > 0
    }

    /**
     * Indique si on doit afficher le montant forfait
     */
    isMontantForfait(): boolean {
        return !this.isMontantHorsForfait();
    }

    /** Indique si la prestation est de type ik ou de type distance */
    isPrestationIkOrTypeDistance(): boolean {
        return this.data.frais.prestation?.bareme
            || [TypeDistance.TYPE_DISTANCE_KM,TypeDistance.TYPE_DISTANCE_MILES].includes(this.data.frais.prestation?.unite?.typeDistance);
    }

    /**
     * Handler qui permet de gérer le trajet et de retourner sur le premier onglet de saisie
     * Appelé par l'onglet trajet
     */
    selectTrajet(listeTrajet: ListeTrajet): void {
        //L'user a sélectionné un trajet, on cache la checkbox
        this.canShowRetenirTrajet = false;

        //Si c'est une tournée
        if (listeTrajet.type === TrajetType.TRAJET_TOURNEE) {
            this.isLoading = true;
            //On récupère la tournée
            this.tourneeService.load(listeTrajet.id, this.data.frais.prestation.idPrestation)
                .pipe(first(),finalize(() => this.isLoading = false))
                .subscribe( (result: Result) => {
                    if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                       this.selectTournee(result.data.tournee);
                    } else {
                        this.toastrService.error(this.translateService.instant('global.errors.enregistrement'));
                    }
                });
        } else {
            //Si c'est un trajet, on enlève la tournée
            this.data.frais.tournee = null;

            //On met à jour les champs localisation
            this.data.frais.localisationDepart = listeTrajet.adresseDepart;
            this.data.frais.localisationArrivee = listeTrajet.adresseArrivee;

            //On a besoin de spécifier l'adresse au bon format pour afficher le libellé
            const formatAdresseFunc = (adresse: Adresse) => `${adresse.rue ? adresse.rue + ', ' : ''} ${adresse.ville}, ${adresse.pays}`;
            this.data.frais.localisationDepart.adresse = formatAdresseFunc(listeTrajet.adresseDepart);
            this.data.frais.localisationArrivee.adresse = formatAdresseFunc(listeTrajet.adresseArrivee);

            //On indique si c'est un aller/retour
            this.data.frais.allerRetour = listeTrajet.allerRetour;

            //Si c'est un trajet admin
            if (listeTrajet.idUser == null) {
                //On ne recalcule pas les km
                this.data.frais.quantite = listeTrajet.distance;

                //On bloque la quantité
                this.isQuantiteBlockedByAdminTrajet = true;
            } else {
                //Si c'est un trajet user, on recalcul les km
                this.updateDistance();
            }

            this.onQuantiteChange();
        }

        //On retourne sur le premier onglet
        this.changeTab(this.matTabGroup,NdfFraisAddTab.saisieFrais);
    }

    /**
     * Suite à la sélection d'une tournée
     * @param tournee
     */
    selectTournee(tournee: Tournee) {
        //On supprime l'id pour ne pas rattacher une tournée perso
        tournee.id = null;

        //On assigne les informations de la tournée
        this.data.frais.tournee =  tournee;

        this.data.frais.quantite = tournee.distance;

        this.onQuantiteChange();
    }

    /**
     * Met à jour la distance dans le modèle
     */
    updateDistance(): void {
        this.isComputingDistance = true;
        this.fraisService.findDistance(this.data.frais.localisationDepart,this.data.frais.localisationArrivee,this.data.frais.allerRetour).pipe(
            catchError(() => of(null))
        ).subscribe({
            next: distance => {
                //Ne pas écraser une quantité existante si la distance n'a pas pu être calculée
                if (distance != null) {
                    this.data.frais.quantite = distance;
                    this.onQuantiteChange();
                }
                this.isComputingDistance = false;
            }
        });
    }

    /**
     * Ouvre la popin tournée
     */
    openPopinTournee(): void  {
        const data = {
            unite: this.data.frais.prestation.unite,
            tournee: this.data.frais.tournee,
            localisationDepart: this.data.frais.localisationDepart,
            localisationArrivee: this.data.frais.localisationArrivee,
            allerRetour: this.data.frais.allerRetour,
            etapesPersonnelles:  this.data.frais.prestation.etapesPersonnelles,
            gestionTempsGlobale:  this.data.frais.prestation.gestionTempsGlobale,
            gestionTempsDetaillee:  this.data.frais.prestation.gestionTempsDetaillee,
            quantiteModifiable: this.data.frais.prestation.quantiteModifiable,
            canModifier: this.data.canModifier,
            idNdf: this.data.ndf.idNDF,
            idUser: this.data.ndf.idUser
        }

        //Ouverture de la popin
        this.matDialog.open(NDFFraisAddTourneeComponent,{data,width: '1200px',}).afterClosed().subscribe({
            next: (tournee: Tournee) => {
                //Si on a valider une tournée
                if (tournee != null) {
                    this.selectTournee(tournee);
                }
            }
        });
    }

    /**
     * Indique si on peut afficher une tournée
     */
    canShowTournee() {
        return this.data.frais.prestation?.geolocalisation && this.data.frais.prestation?.gestionEtapes;
    }

    /**
     * Indique si le choix de l'indemnité est affiché
     */
    canShowIndemnite(): boolean {
        return (!!this.data.frais.prestation && this.saisieState?.tauxPrestation?.allTaux?.length > 0)
            || (this.isIJ && !!this.saisieState?.tauxPrestation?.taux);
    }

    /**
     * En cas d'une erreur sur la prestation, retourne un objet contenant les informations nécessaires à l'affichage du message.
     * Sinon, retourne null.
     */
    get matErrorPrestation(): string | MatErrorModel {
        //Fréquence maximum atteinte
        if (this.hasFrequenceAutoriseeError) {
            //Retour du message traduit
            return this.translateService.instant('ndf.frais.erreur.errorQuantite');
        } else if (this.hasNotAutorisationCirculer() && this.data.settings.niveauControleAutorisationVehiculeNdf === NiveauAutorisation.BLOQUANT) {
            //Le véhicule n'a pas d'autorisation de circuler pour la date sélectionnée
            return {
                error: this.translateService.instant('ndf.frais.erreur.autorisationCirculer',{date: this.datePipe.transform(this.data.frais.date,'shortDate')}),
                css: 'error'
            };
        }

        return null;
    }

    /**
     * En cas d'un warning sur la prestation, retourne un objet contenant les informations nécessaires à l'affichage du warning via le hint.
     * Sinon, retourne null.
     */
    get matHintPrestation(): string | MatHintModel {
        if (this.hasNotAutorisationCirculer() && this.data.settings.niveauControleAutorisationVehiculeNdf === NiveauAutorisation.NON_BLOQUANT) {
            //Le véhicule n'a pas d'autorisation de circuler pour la date sélectionnée mais c'est pas trop grave
            return {
                libelle: this.translateService.instant('ndf.frais.erreur.autorisationCirculer',{date: this.datePipe.transform(this.data.frais.date,'shortDate')}),
                css: 'warning'
            };
        }

        return null;
    }

    /**
     * Met à jour l'indicateur permettant d'afficher ou de masquer la zone d'upload
     */
    checkDocUploaderVisibility(): void {
        //Zone de drag 'n drop visible si le frais n'a pas de PJ
        this.isShowUploader = this.data.canModifier && this.getNbDocuments() === 0;
    }

    /**
     * Définition du handler de l'évènement déclenché lorsque Le fichier entre dans la fenêtre
     *
     * @param evt Évènement déclencheur
     */
    @HostListener('window:dragenter',['$event'])
    onDragEnterWindow(evt: DragEvent): void {
        //Annulation de l'évènement et de sa propagation
        evt.preventDefault();
        evt.stopPropagation();

        //On vérifie qu'on est bien sur l'onglet de saisie
        if (this.currentTab === NdfFraisAddTab.saisieFrais) {
            //Ajout le cas échéant de la classe empêchant les évènements liés au pointeur de la souris
            if (!this.globalOverlay.classList.contains('prevent-drop')) {
                this.globalOverlay.classList.add('prevent-drop');
            }

            //Affichage de la zone de drag 'n drop
            this.isShowUploader = true;
        }
    };

    /**
     * Définition du handler de l'évènement déclenché lorsque Le fichier est déposé
     *
     * @param evt Évènement déclencheur
     */
    @HostListener('window:drop',['$event'])
    onDropWindow(evt: DragEvent): void {
        //Annulation de l'évènement et de sa propagation
        evt.stopPropagation();
        evt.preventDefault();

        //On vérifie qu'on est bien sur l'onglet de saisie
        if (this.currentTab === NdfFraisAddTab.saisieFrais) {
            //Suppression de la classe empêchant les évènements liés au pointeur de la souris
            this.globalOverlay.classList.remove('prevent-drop');
        }
    };

    /**
     * Handler de l'évènement déclenché lorsque Le fichier quitte la fenêtre
     *
     * @param evt Évènement déclencheur
     */
    @HostListener('window:dragleave',['$event'])
    onDragLeaveWindow(evt: DragEvent): void {
        //Annulation de l'évènement et de sa propagation
        evt.stopPropagation();
        evt.preventDefault();

        //On vérifie qu'on est bien sur l'onglet de saisie
        if (this.currentTab === NdfFraisAddTab.saisieFrais) {
            //Vérification de l'attribut relatedTarget
            //Si null c'est que l'évènement n'a pas été déclenché par le survol d'un autre élément mais que le pointeur est simplement sorti de la zone
            if (evt.relatedTarget == null) {
                //Masquage de la zone de drag 'n drop
                this.isShowUploader = false;

                //Suppression de la classe empêchant les évènements liés au pointeur de la souris
                this.globalOverlay.classList.remove('prevent-drop');
            }
        }
    };

    /**
     * Méthode appelée à la fin de l'upload de documents depuis la zone de drag 'n drop de la preview
     *
     * @param files Liste des documents ajoutés
     */
    onAllDocumentUploadedFromPreview(files: Array<Document>): void {
        if (files.length > 0) {
            //Initialisation de la liste des documents le cas échéant
            if (!this.data.frais.listeDocuments) {
                this.data.frais.listeDocuments = [];
            }

            //Mise à jour de la liste des documents
            this.data.frais.listeDocuments.push(...files);
            this.data.frais.nbPJ = (this.data.frais.nbPJ ?? 0) + files.length;

            //Rechargement de la liste des frais à la fermeture du frais
            this.needRefreshAfterPjChanged = true;

            //Vérification du mode création / modification
            if (!this.isCreation()) {
                //Rechargement de la liste des PJ
                this.refreshListPj$.next();
            } else {
                //Ajout manuel (le rechargement via URL est impossible car l'objet n'existe pas encore)
                files.forEach(file => this.listeDocument.liste.addItem(file));
            }

            //Message de succès
            this.toastrService.success(this.translateService.instant('ndf.frais.messageAjoutDocument.' + (files.length > 1 ? 'plural' : 'one'),{count: files.length}));
        }

        //Masque de la zone de drag 'n drop
        this.isShowUploader = false;
    }

    /**
     * Handler appelé après ajout d'un document depuis la liste
     * @param document Le document ajouté
     */
    onDocumentUploadedFromList(document: Document): void {
        if (!!document) {
            //Initialisation de la liste des documents le cas échéant
            if (!this.data.frais.listeDocuments) {
                this.data.frais.listeDocuments = [];
            }

            //Mise à jour de la liste des documents
            this.data.frais.listeDocuments.push(document);
            this.data.frais.nbPJ = (this.data.frais.nbPJ ?? 0) + 1;

            //Rechargement de la liste des frais à la fermeture du frais
            this.needRefreshAfterPjChanged = true;

            //Rafraichissement des alertes requis
            this.isTypePjTouched = true;

            //Message de succès
            this.toastrService.success(this.translateService.instant('ndf.frais.messageAjoutDocument.one'));
        }

        //Affichage de la zone d'upload le cas échéant
        this.checkDocUploaderVisibility();
    }

    /**
     * Méthode appelée après la suppression d'un document depuis la liste des pièces jointes
     *
     * @param name Nom du document pour son identification
     */
    onDocumentRemovedFromList(name: string): void {
        //Récupération de la liste des documents (permettant accessoirement de typer...)
        const listeDocuments: Array<any> = this.data.frais.listeDocuments;

        //Recherche de l'index du document dans la liste
        const index = listeDocuments.findIndex(doc => doc.libelle === name);

        //Suppression du document si trouvé
        if (index >= 0) {
            listeDocuments.splice(index, 1);
        }

        //Mise à jour du nombre de PJ sur l'objet
        this.data.frais.nbPJ = Math.max(0,this.data.frais.nbPJ-1);

        //Demande de rechargement de la liste des frais à la fermeture du frais
        this.needRefreshAfterPjChanged = true;

        //Rafraichissement des alertes requis
        this.isTypePjTouched = true;

        //Affichage de la zone d'upload le cas échéant
        this.checkDocUploaderVisibility();
    }

    /**
     * Retourne le nombre de documents associés au frais, incluant le justificatif en cas d'OCR (lequel n'est pas comptabilisé dans le champ nbPJ du frais)
     */
    getNbDocuments(): number {
        return this.data.frais.listeDocuments?.length ?? 0;
    }

    /**
     * Retourne un warning s'il y a un contrôle non bloquant sur la date
     *
     * @param date la date à vérifier
     * @returns "warning" s'il y a un avertissement sur la date
     */
    getDateWarning(date: Date): string {
        const empty = '';

        //S'il y a un contrôle non bloquant sur la date
        if (this.isDateWarning(date) && !this.isDateError(date)) {
            return "warning";
        }

        return empty;
    }

    /**
     * Retourne le message du tooltip de date
     *
     * @param date la date à vérifier
     * @returns l'objet contenant le message et les options du tooltip, ou null si aucun message n'est à afficher
     */
    getMessageToolTip(date: Date) {
        //Initialisation du contenu du tooltip
        this.dateTooltipContent = "";

        //Vérification du contrôle bloquant sur la date future
        if (this.isDateFutureControle(date,Anomalie.BLOQUANT)) {
            //Ajout du message d'erreur sur la date future au tooltip
            this.dateTooltipContent = this.translateService.instant('ndf.frais.erreur.depenseFuture');
        }

        //Vérification du contrôle bloquant sur la date hors mission
        if (this.isDateHorsMissionControle(date,Anomalie.BLOQUANT)) {
            //Ajout d'un retour à la ligne s'il y a déjà un message
            if (this.dateTooltipContent.trim().length > 0) {
                this.dateTooltipContent += "\r\n";
            }

            //Ajout du message d'erreur sur la date hors mission au tooltip
            this.dateTooltipContent += this.translateService.instant('ndf.frais.erreur.depenseHorsMission');
        }

        //Si un message d'erreur a été ajouté au tooltip
        if (this.dateTooltipContent.trim().length > 0) {
            //Retourne l'objet pour le tooltip
            return {content: this.dateTooltipContent,
                options: {position: 'above' as TooltipPosition,
                    tooltipClass: 'custom-tooltip-date'}
            };
        }

        //Vérification des contrôles non bloquants sur la date future
        if (this.isDateFutureControle(date,Anomalie.NON_BLOQUANT)) {
            //Ajout du message d'avertissement sur la date future au tooltip
            this.dateTooltipContent = this.translateService.instant('ndf.frais.erreur.depenseFutureAvertissement');
        }

        //Vérification des contrôles non bloquants sur la date hors mission
        if (this.isDateHorsMissionControle(date,Anomalie.NON_BLOQUANT)) {
            //Ajout d'un retour à la ligne s'il y a déjà un message
            if (this.dateTooltipContent.trim().length > 0) {
                this.dateTooltipContent += "\r\n";
            }

            //Ajout du message d'avertissement sur la date hors mission au tooltip
            this.dateTooltipContent += this.translateService.instant('ndf.frais.erreur.depenseHorsMissionAvertissement');
        }

        //Si un message d'avertissement a été ajouté au tooltip
        if (this.dateTooltipContent.trim().length > 0) {
            //Retourne l'objet pour le tooltip
            return {content: this.dateTooltipContent,
                options: {position: 'above' as TooltipPosition,
                    tooltipClass: 'custom-tooltip-date'}
            };
        } else {
            //Pas d'erreur, on retourne null
            return null;
        }
    }

    /**
     * Indicateur de contrôle non bloquant sur la date
     *
     * @param date la date à vérifier
     * @returns Un indicateur s'il y a un avertissement sur la date
     */
    isDateWarning(date: Date): boolean {
        //Retourne un indicateur de contrôle non bloquant sur la date
        return this.isDateFutureControle(date,Anomalie.NON_BLOQUANT) || this.isDateHorsMissionControle(date,Anomalie.NON_BLOQUANT);
    }

    /**
     * Indicateur de contrôle bloquant sur la date
     *
     * @param date la date à vérifier
     * @returns Un indicateur s'il y a une erreur sur la date
     */
    isDateError(date: Date): boolean {
        //Retourne un indicateur de contrôle bloquant sur la date
        return this.isDateFutureControle(date,Anomalie.BLOQUANT) || this.isDateHorsMissionControle(date,Anomalie.BLOQUANT);
    }

    /**
     * Indicateur sur une date future
     *
     * @param date la date à vérifier
     * @param anomalie le type de contrôle à vérifier : BLOQUANT, NON_BLOQUANT
     * @returns Un indicateur si la date est en erreur selon le type de contrôle sur la date future
     */
    isDateFutureControle(date: Date, anomalie: Anomalie): boolean {
        //Si on a une date et s'il y a un contrôle sur les dépenses futures
        if (!!date && this.data.settings.anomalieDepensesFutures === anomalie){
            //Date du jour
            const today = moment().startOf('day');

            //Si la date est supérieur à la date du jour
            return moment().isBefore(date, 'day');
        }
        return false;
    }

    /**
     * Indicateur sur une date hors mission
     *
     * @param date la date à vérifier
     * @param anomalie le type de contrôle à vérifier : BLOQUANT, NON_BLOQUANT
     * @returns Un indicateur si la date est en erreur selon le type de contrôle sur la date hors mission
     */
    isDateHorsMissionControle(date: Date, anomalie: Anomalie): boolean {
        let odDepart: Moment;
        let odRetour: Moment;

        //Si on a une date od ou de saisie et s'il y a un contrôle sur les dates hors mission
        if (!!date && this.data.settings.anomalieDepensesHorsMission === anomalie
            && (
                (this.data.ndf?.od?.depart_le && this.data.ndf?.od?.retour_le)
                || (this.saisieTemps?.debutReel && this.saisieTemps?.finReel)
            )) {
            //Si on a une saisie de temps
            if (this.saisieTemps?.debutReel && this.saisieTemps?.finReel) {
                //Date de saisie
                odDepart = moment(this.saisieTemps?.debutReel).startOf('day');
                odRetour = moment(this.saisieTemps?.finReel).startOf('day');
            } else {
                //Date de mission
                odDepart = moment(this.data.ndf.od.depart_le).startOf('day');
                odRetour = moment(this.data.ndf.od.retour_le).startOf('day');
            }

            //Si la date est hors mission
            return odDepart.isAfter(date, 'day') || odRetour.isBefore(date, 'day');
        }
        return false;
    }

    /**
     * Indicateur de contrôle (bloquant ou non bloquant) sur la date hors mission
     *
     * @param date la date à vérifier
     * @returns Un indicateur s'il y a une anomalie (bloquante ou non bloquante) sur la date hors mission
     */
    isDateHorsMissionBloquanteOuNonBloquante(date: Date): boolean {
        //S'il y a un contrôle bloquant ou non bloquant sur la date hors-mission
        return this.isDateHorsMissionControle(date, Anomalie.BLOQUANT)
            || this.isDateHorsMissionControle(date, Anomalie.NON_BLOQUANT);
    }

    /**
     * Retourne un warning pour une anomalie
     */
    getMontantWarning(montant: number): string {
        //Si on a un montant et que le paramétrage est sur non bloquant et que le montant est négatif
        if (montant != null && this.data.settings.anomalieDepensesNegatives === Anomalie.NON_BLOQUANT && montant < 0) {
            return "warning";
        }

        return '';
    }

    /**
     * Indique si le montant est en erreur par rapport au paramétrage
     */
    isMontantError(montant: number): boolean {
        //Si on a un montant avec le paramétrage en bloquant et le montant négatif
        return this.data.settings.anomalieDepensesNegatives === Anomalie.BLOQUANT && montant != null && montant <= 0;
    }

    /**
     * Indique si le déplafonnement est utilisable
     */
    hasDeplafonnement(): boolean {
        const prestation = this.data.frais.prestation;

        //La prestation est de type plafond
        //Dans la fiche prestation, le déplafonnement n'est pas interdit
        //Dans la fiche utilisateur, le déplafonnement est autorisé
        return prestation != null
            && prestation.type === TypePrestation.PLAFOND
            && !prestation.disableDeplaf
            && this.deplaf;
    }

    /**
     * Vérifie si on affiche le champ frais carte
     */
    checkIsFraisCarteVisible() {
        //URL de Récupération de la liste des opérations carte
        const url = `${environment.baseUrl}/controller/OpeCarte/listeCarte${this.data.ndf.idUser !== this.user?.idUser && this.user?.idUser != null ? '/' + this.data.ndf.idUser : ''}`;

        //Récupération de la liste des opérations carte
        this.http.post<any>(url, {listeFilter: [{clef: "etatOperation", valeur: null, listeObjects: [EtatOperation.PARTIELLEMENT_JUSTIFIE, EtatOperation.NON_JUSTIFIE], typeComparaison: "IN"}]}).subscribe(
            (response) => {
                const opeCarte = response.listeResultats;

                //Visible seulement si l'utilisateur a une opération carte
                this.isFraisCarteVisible = this.data.settings.opeCarteActif && (opeCarte && opeCarte.length > 0 || this.data.frais.operation.opeCarte);
            }
        );
    }

    /**
     * Handler du changement du montant de base
     */
    onMontantBaseChange() {
        //Quand on change le montant de base
        this.data.frais.saisieTaxe.listeTaxes.forEach(taux => {
            //Si on a pas de saisie
            if (taux.montantBase == null || taux.montantBase == '') {
                //On force le 0
                taux.montantBase = 0;
            }
        });
    }

    /**
     * Retourne true si on doit afficher une alerte concernant les types de pièces jointes
     */
    isAlerteTypePieceJointe(): boolean {
        //Si les paramètres de pièces jointes requièrent obligatoirement un type et que le mode de gestion des PJ est soit [NDF+Frais] soit [Frais seul].
        const isTypePjObligatoire: boolean = this.pieceJointeParams?.type && this.pieceJointeParams?.typeObligatoire
            && (this.pieceJointeParams?.modeGestion == 1 || this.pieceJointeParams?.modeGestion == 3);

        //Si la liste contient des documents sans type de PJ sélectionné
        const isListeWithTypePjManquant: boolean = !!this.listeDocument?.liste?.data?.listeResultats
            ?.some(d => d.typeDocument?.idTypeDocument == NO_SELECTION || d.typeDocument?.idTypeDocument == null);

        //Retourne true si le type de PJ est obligatoire et que la liste contient des documents sans type
        return isTypePjObligatoire && isListeWithTypePjManquant;
    }

    /** Étiquette personnalisée avec sélection intégrée */
    readonly customTagWithSelect: (document: Document) => CustomTagWithSelect<Document,number|typeof NO_SELECTION> = (document: Document) => {
        //Si les paramètres de pièces jointes requièrent un type et que le mode de gestion des PJ est soit [NDF+Frais] soit [Frais seul].
        if (this.pieceJointeParams?.type && (this.pieceJointeParams?.modeGestion == 1 || this.pieceJointeParams?.modeGestion == 3)) {
            //On retourne l'étiquette personnalisée
            return {
                libelle: 'document.custom.pieceJointe.type',
                ngModel: () => document.typeDocument?.idTypeDocument ?? NO_SELECTION,
                options: ((this.pieceJointeParams?.typeObligatoire && document?.typeDocument?.idTypeDocument != NO_SELECTION && document?.typeDocument?.idTypeDocument != null && []) || [{
                    libelle: 'document.custom.pieceJointe.aucun',
                    value: NO_SELECTION
                }]).concat(this.typesDocument?.length ? this.typesDocument.map(t => ({ libelle: t.libelle, value: t.idTypeDocument as any })) : []),
                onSelectionChange: (selection: number|typeof NO_SELECTION, customTag: CustomTagWithSelect<Document,number|typeof NO_SELECTION>) => {
                    //Mise à jour de la donnée locale
                    document.typeDocument = { idTypeDocument: selection } as TypeDocument;

                    //Si le frais a déjà été enregistré (il a donc un ID).
                    if (!!this.data?.frais?.idDepense || !!this.data?.frais?.idFrais) {
                        //Enregistrement direct du type de PJ
                        this.saveTypePieceJointe(
                            document.idDocument,
                            selection === NO_SELECTION ? null : { idTypeDocument: selection } as TypeDocument,
                            customTag
                        );
                    } else {
                        //Sinon, si le type est obligatoire
                        if (this.pieceJointeParams?.typeObligatoire) {
                            //Suppression du choix AUCUN de la liste des possibilités
                            customTag.options = customTag.options.filter(o => o.value !== NO_SELECTION);
                        }

                        //Stockage temporaire du nouveau type dans une Map afin de pouvoir sauvegarder le frais AVANT
                        this.bufferMapForTypePiecesJointes.set(
                            document.idDocument,
                            selection === NO_SELECTION ? null : { idTypeDocument: selection } as TypeDocument
                        );
                    }
                },
                isError: () => { return this.pieceJointeParams?.typeObligatoire && (document?.typeDocument?.idTypeDocument === NO_SELECTION || document?.typeDocument?.idTypeDocument == null); },
                isDisabled: () => { return !this.data?.canModifier; }
            } as CustomTagWithSelect<Document,number|typeof NO_SELECTION>;
        } else {
            //Sinon, on retourne undefined
            return undefined;
        }
    };

    /**
     * Enregistrement du type de PJ
     *
     * @param idDocument ID du document
     * @param typeDocument Type de PJ
     * @param customTag (nullable) CustomTag
     */
    saveTypePieceJointe(idDocument: number, typeDocument: TypeDocument, customTag?: CustomTagWithSelect<Document,number|typeof NO_SELECTION>): Promise<void> {
        return new Promise(resolve => {
            //Indicateur d'enregistrement en cours
            this.isSaving = true;

            //Incrément du nombre d'enregistrements en cours
            this.countSavingTypePieceJointe++;

            //Enregistrement de la nouvelle valeur en base
            this.pieceJointeUserService.saveTypeForDocument({
                idDocument: idDocument,
                typeDocument: typeDocument
            } as Document,this.contexte)
                .pipe(first())
                .pipe(handleResult(this.translateService,this.toastrService,'global.success.enregistrement','global.errors.enregistrement'))
                .subscribe((result) => {
                    //En cas de succès
                    if (!!result) {
                        //Si le type est obligatoire
                        if (this.pieceJointeParams?.typeObligatoire && customTag) {
                            //Suppression du choix AUCUN de la liste des possibilités
                            customTag.options = customTag.options.filter(o => o.value !== NO_SELECTION);
                        }

                        //Rechargement de la liste des frais à la fermeture du frais
                        this.needRefreshAfterPjChanged = true;

                        //Rafraichissement des alertes requis
                        this.isTypePjTouched = true;
                    }

                    //Décrément du nombre d'enregistrements en cours
                    this.countSavingTypePieceJointe--;

                    //Indicateur d'enregistrement en cours
                    this.isSaving = !!this.countSavingTypePieceJointe;

                    //Fin de la promesse
                    resolve();
                });
        });
    }
}

/**
 * Enum pour les onglets add frais
 */
enum NdfFraisAddTab {
    saisieFrais = 0,
    mesFrais = 1,
    pieceJointe = 2
}
